import BaseAutomationAction from './BaseAutomationAction.js';

class RecordAutomationAction extends BaseAutomationAction {
    execute({automation, value, oldValue}) {
        return {
            points: automation.record(value, oldValue),
            automation
        };
    }

    undo({payload}) {
        payload.points.forEach(
            pt => 
                payload.automation.removeBreakPoint(pt));
    }
}

export default RecordAutomationAction;
